import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { ASSET_GROUP_LIST, ASSET_GROUP_DATA, ASSET_GROUP_CREATE, ASSET_GROUP_UPDATE, ASSET_GROUP_DELETE } from "./actionType";
import {
  assetGroupListSuccess, assetGroupListFailure,
  assetGroupDataSuccess, assetGroupDataFailure,
  assetGroupCreateSuccess, assetGroupCreateFailure,
  assetGroupUpdateSuccess, assetGroupUpdateFailure,
  assetGroupDeleteSuccess, assetGroupDeleteFailure,
} from "./action";
import { assetGroupListApi, assetGroupDataApi, assetGroupCreateApi, assetGroupUpdateApi, assetGroupDeleteApi } from "../../helpers/fakebackend_helper";

function* handleList()            { try { yield put(assetGroupListSuccess(yield call(assetGroupListApi)));              } catch (e) { yield put(assetGroupListFailure(e));   } }
function* handleData({ payload }) { try { yield put(assetGroupDataSuccess(yield call(assetGroupDataApi, payload)));     } catch (e) { yield put(assetGroupDataFailure(e));   } }
function* handleCreate({ payload }){ try { yield put(assetGroupCreateSuccess(yield call(assetGroupCreateApi, payload)));} catch (e) { yield put(assetGroupCreateFailure(e)); } }
function* handleUpdate({ payload }){ try { yield put(assetGroupUpdateSuccess(yield call(assetGroupUpdateApi, payload)));} catch (e) { yield put(assetGroupUpdateFailure(e)); } }
function* handleDelete({ payload }){ try { yield put(assetGroupDeleteSuccess(yield call(assetGroupDeleteApi, payload)));} catch (e) { yield put(assetGroupDeleteFailure(e)); } }

export default function* AssetGroupSaga() {
  yield all([
    fork(function* () { yield takeEvery(ASSET_GROUP_LIST,   handleList);   }),
    fork(function* () { yield takeEvery(ASSET_GROUP_DATA,   handleData);   }),
    fork(function* () { yield takeEvery(ASSET_GROUP_CREATE, handleCreate); }),
    fork(function* () { yield takeEvery(ASSET_GROUP_UPDATE, handleUpdate); }),
    fork(function* () { yield takeEvery(ASSET_GROUP_DELETE, handleDelete); }),
  ]);
}
